import React from "react";
import Height from "./Height";
import Weight from "./Weight";
import Gender from "./Gender";
import Age from "./Age";
import Results from "./Results";

export default function App() {
    const [gender, setGender] = React.useState(null)
    const [weight, setWeight] = React.useState(undefined)
    const [height, setHeight] = React.useState(undefined)
    const [age, setAge] = React.useState(undefined);
    const [BMR, setBMR] = React.useState(null)
    const [chartSize, setChartSize] = React.useState({ width: 310, height: 500 });

    React.useEffect(() => {
        if (gender && weight && height && age) {
            const weightExp = Math.pow(weight, 0.48);
            const heightExp = Math.pow(height / 100, 0.50);
            const ageExp = Math.pow(age, -0.13);
            const multiplier = gender === 'male' ? 259 : 230;

            const calculatedBMR = multiplier * (weightExp * heightExp * ageExp);
            setBMR(calculatedBMR.toFixed(1));
        }
    }, [gender, weight, height, age]);

    React.useEffect(() => {
        function handleResize() {
            if (window.innerWidth >= 640) {
                setChartSize({ width: 440, height: 300 });
            } else {
                setChartSize({ width: 310, height: 300 });
            }
        }

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>
            <div className="flex w-full text-center gap-2 sm:gap-4">
                <Gender
                    onClick={() => setGender("male")}
                    gender="male"
                    selected={gender == "male"}
                />
                <Gender
                    onClick={() => setGender("female")}
                    gender="female"
                    selected={gender == "female"}
                />
            </div>

            <div className="p-4 my-2 sm:my-4 bg-stone-100 rounded-lg flex gap-6">
                <Weight onChange={(newWeight) => setWeight(newWeight)} />
                <Height onChange={(newHeight) => setHeight(newHeight)} />
            </div>

            <div className="p-4 my-2 sm:my-4 bg-stone-100 rounded-lg flex gap-12">
                <Age onChange={(newAge) => setAge(Number(newAge))} />
            </div>

            <div className="mb-2 font-bold text-center w-full sm:text-lg cursor-default">
                Résultats
            </div>

            <div className="py-4 my-2 sm:my-4 rounded-lg w-full ">
                <Results BMR={BMR} width={chartSize.width} height={chartSize.height} />
            </div>
        </>
    );
}